// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StrokeHistoryOverlay.css */
.history-menu {
  position: fixed;
  max-height: 90vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 10px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.history-menu * {
  touch-action: pan-y;
}

.history-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
}

.history-title {
  color: var(--tg-theme-button-color);
  font-size: 22px;
  flex-shrink: 0;
}

.history-category-switcher {
  display: flex;
  justify-content: center;
  gap: 5px;
  padding: 5px 0;
}

.history-category-btn {
  padding: 6px 12px;
  border-radius: 12px;
  cursor: pointer;
  color: var(--tg-theme-button-color);
  background: var(--tg-theme-bg-color);
  border: none;
}

.history-category-btn.active {
  background: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
}

.history-list {
  overflow-y: auto;
  width: 100%;
  flex-grow: 1;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column-reverse;
}

.history-item {
  margin-bottom: 3px;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.history-item-info {
  display: block;
  font-size: 13px;
  color: var(--tg-theme-text-color);
  opacity: 0.8;
}

.stroke-preview {
  width: 25px;
  height: 25px;
  border-radius: 4px;
  margin-left: 5px;
}

.semi-bold {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/board/history/StrokeHistoryOverlay.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* StrokeHistoryOverlay.css */\r\n.history-menu {\r\n  position: fixed;\r\n  max-height: 90vh;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 300px;\r\n  text-align: center;\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 10px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 12px;\r\n  z-index: 1100;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.history-menu * {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.history-header {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.history-title {\r\n  color: var(--tg-theme-button-color);\r\n  font-size: 22px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.history-category-switcher {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  padding: 5px 0;\r\n}\r\n\r\n.history-category-btn {\r\n  padding: 6px 12px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  color: var(--tg-theme-button-color);\r\n  background: var(--tg-theme-bg-color);\r\n  border: none;\r\n}\r\n\r\n.history-category-btn.active {\r\n  background: var(--tg-theme-button-color);\r\n  color: var(--tg-theme-button-text-color);\r\n}\r\n\r\n.history-list {\r\n  overflow-y: auto;\r\n  width: 100%;\r\n  flex-grow: 1;\r\n  margin-bottom: 5px;\r\n  display: flex;\r\n  flex-direction: column-reverse;\r\n}\r\n\r\n.history-item {\r\n  margin-bottom: 3px;\r\n  padding: 5px 10px;\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n  border-radius: 8px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.history-item-info {\r\n  display: block;\r\n  font-size: 13px;\r\n  color: var(--tg-theme-text-color);\r\n  opacity: 0.8;\r\n}\r\n\r\n.stroke-preview {\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 4px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.semi-bold {\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
